export const hash = '4018e66f-2968-482d-bba3-b78606b07af8';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6LdoQWIeAAAAAP457cno1Yt_wU6F2dbJxz-M_vCY';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br/';
//export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const defaultProjectHash = '';
export const urlWebsite = 'https://fronteiras-na-insuficiencia-cardiaca-2024.encontrodigital.com.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'Fronteiras na Insuficiência Cardíaca Avançada, Transplante e Suporte Cardiocirculatório Mecânico 2024';
export const logo = '/assets/logo2.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'Fronteiras na Insuficiência Cardíaca Avançada, Transplante e Suporte Cardiocirculatório Mecânico 2024';
export const dadosOrganizacao = '';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
  website: ''
};


export const defaultTheme = {
  defaultBackground: 'rgb(0,14,64)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: 'none',
    backgroundMobile: 'rgb(0,14,64)',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};


